export default "__VITE_ASSET__DGuVb6yx__"